<template>
  <div class="content">
    <div class="inner">
      <Tabs v-model="tab" :animated="false" @on-click="toggleBar">
        <TabPane
          :label="item.label"
          :name="item.value"
          v-for="item in tabList"
          :key="item.value"
          v-if="item.show"
        ></TabPane>
      </Tabs>
      <component
        :is="componentName"
        :key="componentName"
        :ref="componentName"
        @changeTabsBtn="changeTabsBtn"
        @exportForm="$emit('exportForm')"
      ></component>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import myBrokerage from "./brokerage/myBrokerage.vue";

export default {
  components: {
    myBrokerage,
  },
  props: {},
  data() {
    return {
      tab: "1",
      componentName: "myBrokerage",
      tabList: [
        {
          label: "上游对账数据",
          value: "1",
          name: "myBrokerage",
          show: true,
        },
      ],
    };
  },
  watch: {},
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    if (this.userInfo.userType == 4) {
      this.tabList[1].show = false;
    }
    if (this.userInfo.levelCode == "10005" || this.userInfo.userType == 4) {
      this.tabList[2].show = false;
    }
  },
  mounted() {},
  methods: {
    toggleBar() {
      //切换tab
      const cur = this.tabList.find((item) => item.value === this.tab);
      this.componentName = cur.name;
      this.$emit("toggleBar", cur.name);
      this.$emit('changeTabsBtn',0)
    },
    changeTabsBtn(v){
      this.$emit('changeTabsBtn',v)

    }
  },
};
</script>
<style lang="scss" scoped>
.content {
  .inner {
    background: #fff;
      /deep/ {
      .ivu-tabs-bar {
        border-bottom: 1px solid #ECECEC;
      }
      .ivu-tabs-ink-bar {
        display: none;
      }
      .ivu-tabs-tab {
        padding: 9px 0 10px;
        margin-right: 44px;
        font-size: 14px;
        color: #515C6F;
      }
      .ivu-tabs-tab-active{
        position: relative;
        color: #236DFF;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 1px;
          height: 2px;
          width: 100%;
          background-color: #236DFF;
        }
      }    
    }
  }
  /deep/ .searchBox {
    .left {
      width: auto !important;
    }
    .right {
      position: static;
      margin-left: 20px;
    }
  }
  /deep/ .ivu-col-span-6,
  /deep/ .ivu-col-span-8 {
    max-width: 100% !important;
    .formItem {
      width: 300px;
    }
  }
  /deep/ .formGroup .ivu-col {
    width: 300px;
  }
}
</style>
